import BaseModel from '../base';

export default class AssociationRatingHistory extends BaseModel {
  constructor(item = {}, url) {
    super(item, url);

    this.user_id = item.user_id ?? null;
    this.event_association_id = item.event_association_id ?? null;
    this.event_association_feature_id = item.event_association_feature_id ?? null;
    this.region_id = item.region_id ?? null;

    this.rating = Number(item.rating ?? 0);
    this.user_name = item.user_name || '';
    this.association_name = item.association_name || '';
    this.feature_name = item.feature_name || '';
    this.region_name = item.region_name || '';

    this.event_ids = Array.isArray(item.event_ids) ? item.event_ids : [];
    this.event_count = this.event_ids.length;

    this.event_id = item.event_id ?? null;
    this.award = item.award || null;
    this.user = item.user || null;
    this.association = item.association || null;
    this.feature = item.feature || null;
    this.created_at = item.created_at || null;
    this.updated_at = item.updated_at || null;

    this.name = this.user_name || this.feature_name || this.association_name || this.name;
  }

  get displayName() {
    return this.user_name || this.feature_name || this.association_name || this.name;
  }
}
